export const TOLL_STATE = 'TOLL_STATE';
